import { NOTIFICATIONS_PORTAL_CONTAINER_ID } from "./constants";

const createNotificationsPortalContainer = () => {
  const notificationsPortalContainer = document.createElement("div");

  notificationsPortalContainer.setAttribute(
    "id",
    NOTIFICATIONS_PORTAL_CONTAINER_ID
  );

  document.body.appendChild(notificationsPortalContainer);

  return notificationsPortalContainer;
};

export const getNotificationsPortalContainer = () =>
  document.getElementById(NOTIFICATIONS_PORTAL_CONTAINER_ID) ||
  createNotificationsPortalContainer();
